{
  "electronicJournalHost": "https://transaction-lookup.{{ej_region}}.retailprinting-test.nikecloud.com",
  "electronicJournalCnHost": "https://transaction-lookup.{{ej_region}}.c4c-retail-comm-svc-test.nikecloud.com.cn",
  "oktaAuthorizeResource" : "/v1/qa/authorize",
  "oktaTokenResource": "/v1/qa/token",
  "receiptsHost": "https://generate-retail-labels-v1.retailprinting-test.nikecloud.com",
  "storeviewsHost": "https://storeviews-regional-us-east-1.risedomain-test.nikecloud.com"
}
